export default {
  name: 'ExportCheckFileModal',
  props: {
    exportSetting: {}
  },
}